import { render } from "./HDadd.vue?vue&type=template&id=c20514b8&scoped=true"
import script from "./HDadd.vue?vue&type=script&lang=js"
export * from "./HDadd.vue?vue&type=script&lang=js"

import "./HDadd.vue?vue&type=style&index=0&id=c20514b8&lang=scss&scoped=true"
import "./HDadd.vue?vue&type=style&index=1&id=c20514b8&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c20514b8"]])

export default __exports__